import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useField } from '@unform/core'
import InputMask from 'react-input-mask'

function MaskInput({ id, label, name, children, mask, maskChar, ...props }) {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value'
    })
  }, [fieldName, registerField]);

  return (
    <div className="form-group">
      {label && <label htmlFor={id}>{label}</label>}
      <InputMask mask={mask} maskChar={maskChar}
        ref={inputRef} 
        id={id}
        className="form-control"
        defaultValue={defaultValue} 
        {...props} />
      {children}
      {error && <p className="text-danger">{error}</p>}
    </div>
  )
}

MaskInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  children: PropTypes.any,
  mask: PropTypes.string.isRequired,
  maskChar: PropTypes.string
}

MaskInput.defaultProps = {
  maskChar: ' '
}

export default MaskInput;